var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getBusinessPermission || _vm.userType == "super_admin"
    ? _c("div", { staticClass: "setting-main-container" }, [
        _c(
          "div",
          { staticClass: "card setting-card" },
          [
            _c(
              "table-component",
              {
                ref: "stakeholderTable",
                staticClass: "mb-3",
                attrs: {
                  "show-filter": false,
                  data: _vm.stakeholders,
                  "table-class": "table tax-table",
                },
              },
              [
                _c("table-column", {
                  attrs: {
                    sortable: true,
                    label: _vm.$t("profile.stakeholder.name"),
                    show: "name",
                  },
                }),
                _vm._v(" "),
                _c("table-column", {
                  attrs: {
                    sortable: true,
                    label: _vm.$t("profile.stakeholder.role"),
                    show: "role",
                  },
                }),
                _vm._v(" "),
                _c("table-column", {
                  attrs: {
                    sortable: true,
                    label: _vm.$t("profile.stakeholder.cnic"),
                    show: "cnic",
                  },
                }),
                _vm._v(" "),
                _c("table-column", {
                  attrs: {
                    sortable: false,
                    filterable: false,
                    "cell-class": "action-dropdown",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("settings.tax_types.action"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-dropdown",
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { slot: "activator", href: "#" },
                                    slot: "activator",
                                  },
                                  [_c("dot-icon")],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewStakeHolder(row)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["fas", "eye"] },
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("general.view")) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3227893315
                  ),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }